import { StructureRow } from "./types/wall";

export enum Joint {
  Vertical,
  Horizontal,
}

export enum JointSize {
  Glued = 3,
  Small = 6,
  Large = 12,
}

export enum StructureType {
  HalfBrick = "Half",
  Wild = "Wild",
  Stack = "Stack",
  Cross = "Cross",
  // Baekel,
}

export enum BrickPattern {
  Full = "full",
  Half = "half",
  // Baekel = "baekel",
}

export enum BrickSizes {
M50 = "M50",
  M65 = "M65",
  HF = "HF",
  WF = "WF",
  DL = "DL",
  DF40 = "DF 40",
  DF52 = "DF 52",
  LF36540 = "LF 365/40",
  LF36552 = "LF 365/52",
  LF490 = "LF 490"
}

export interface JointClass {
  name: string;
  img: string;
}

export interface Structure {
  name: string;
  rows: StructureRow[];
}

export const brickSizes: Record<
  BrickSizes,
  { width: number; height: number }
> = {
  [BrickSizes.M50]: {
    width: 190,
    height: 50,
  },
  [BrickSizes.M65]: {
    width: 190,
    height: 65,
  },
  [BrickSizes.HF]: {
    width: 240,
    height: 40,
  },
  [BrickSizes.WF]: {
    width: 210,
    height: 50,
  },
  [BrickSizes.DL]: {
    width: 290,
    height: 50,
  },
  [BrickSizes.DF40]: {
    width: 240,
    height: 40,
  },
  [BrickSizes.DF52]: {
    width: 240,
    height: 52,
  },
  [BrickSizes.LF36540]: {
    width: 365,
    height: 40,
  },
  [BrickSizes.LF36552]: {
    width: 365,
    height: 52,
  },
  [BrickSizes.LF490]: {
    width: 490,
    height: 40,
  }
};

export const structures: Record<StructureType, Structure> = {
  [StructureType.HalfBrick]: {
    name: "Halfsteens",
    rows: [
      { pattern: [BrickPattern.Full], margin: -0.5 },
      { pattern: [BrickPattern.Full], margin: 0 },
    ],
  },
  [StructureType.Wild]: {
    name: "Wild",
    rows: [
      {
        pattern: [
          BrickPattern.Half,
          BrickPattern.Full,
          BrickPattern.Full,
          BrickPattern.Full,
          BrickPattern.Half,
          BrickPattern.Full,
          BrickPattern.Half,
          BrickPattern.Full,
          BrickPattern.Full,
          BrickPattern.Half,
          BrickPattern.Full,
          BrickPattern.Full,
          BrickPattern.Full,
          BrickPattern.Half,
          BrickPattern.Half,
          BrickPattern.Full,
        ],
        margin: -0.5,
      },
      {
        pattern: [
          BrickPattern.Full,
          BrickPattern.Half,
          BrickPattern.Full,
          BrickPattern.Half,
          BrickPattern.Full,
          BrickPattern.Half,
          BrickPattern.Full,
          BrickPattern.Full,
          BrickPattern.Half,
          BrickPattern.Full,
          BrickPattern.Full,
          BrickPattern.Full,
          BrickPattern.Half,
          BrickPattern.Full,
          BrickPattern.Full,
        ],
        margin: 0,
      },
      {
        pattern: [
          BrickPattern.Half,
          BrickPattern.Half,
          BrickPattern.Full,
          BrickPattern.Full,
          BrickPattern.Full,
          BrickPattern.Half,
          BrickPattern.Full,
          BrickPattern.Full,
          BrickPattern.Full,
          BrickPattern.Half,
          BrickPattern.Full,
          BrickPattern.Half,
          BrickPattern.Full,
          BrickPattern.Full,
          BrickPattern.Full,
          BrickPattern.Half,
        ],
        margin: -0.5,
      },
      {
        pattern: [
          BrickPattern.Full,
          BrickPattern.Half,
          BrickPattern.Full,
          BrickPattern.Half,
          BrickPattern.Full,
          BrickPattern.Full,
          BrickPattern.Half,
          BrickPattern.Half,
          BrickPattern.Full,
          BrickPattern.Full,
          BrickPattern.Full,
          BrickPattern.Full,
          BrickPattern.Half,
          BrickPattern.Full,
          BrickPattern.Full,
        ],
        margin: 0,
      },
      {
        pattern: [
          BrickPattern.Half,
          BrickPattern.Full,
          BrickPattern.Half,
          BrickPattern.Full,
          BrickPattern.Half,
          BrickPattern.Full,
          BrickPattern.Half,
          BrickPattern.Full,
          BrickPattern.Full,
          BrickPattern.Full,
          BrickPattern.Full,
          BrickPattern.Half,
          BrickPattern.Full,
          BrickPattern.Full,
          BrickPattern.Half,
          BrickPattern.Full,
        ],
        margin: -0.5,
      },
      {
        pattern: [
          BrickPattern.Full,
          BrickPattern.Full,
          BrickPattern.Half,
          BrickPattern.Full,
          BrickPattern.Full,
          BrickPattern.Half,
          BrickPattern.Full,
          BrickPattern.Full,
          BrickPattern.Full,
          BrickPattern.Half,
          BrickPattern.Full,
          BrickPattern.Full,
          BrickPattern.Half,
        ],
        margin: 0,
      },
      {
        pattern: [
          BrickPattern.Half,
          BrickPattern.Full,
          BrickPattern.Full,
          BrickPattern.Full,
          BrickPattern.Half,
          BrickPattern.Full,
          BrickPattern.Full,
          BrickPattern.Full,
          BrickPattern.Half,
          BrickPattern.Half,
          BrickPattern.Full,
          BrickPattern.Half,
          BrickPattern.Full,
          BrickPattern.Half,
          BrickPattern.Full,
          BrickPattern.Full,
        ],
        margin: -0.5,
      },
      {
        pattern: [
          BrickPattern.Full,
          BrickPattern.Half,
          BrickPattern.Full,
          BrickPattern.Full,
          BrickPattern.Half,
          BrickPattern.Half,
          BrickPattern.Full,
          BrickPattern.Full,
          BrickPattern.Full,
          BrickPattern.Half,
          BrickPattern.Full,
          BrickPattern.Half,
          BrickPattern.Full,
          BrickPattern.Full,
          BrickPattern.Full,
        ],
        margin: 0,
      },
      {
        pattern: [
          BrickPattern.Half,
          BrickPattern.Full,
          BrickPattern.Half,
          BrickPattern.Full,
          BrickPattern.Half,
          BrickPattern.Full,
          BrickPattern.Full,
          BrickPattern.Half,
          BrickPattern.Half,
          BrickPattern.Full,
          BrickPattern.Full,
          BrickPattern.Half,
          BrickPattern.Full,
          BrickPattern.Full,
          BrickPattern.Full,
          BrickPattern.Full,
        ],
        margin: -0.5,
      },
      {
        pattern: [
          BrickPattern.Full,
          BrickPattern.Half,
          BrickPattern.Full,
          BrickPattern.Full,
          BrickPattern.Half,
          BrickPattern.Full,
          BrickPattern.Full,
          BrickPattern.Half,
          BrickPattern.Full,
          BrickPattern.Half,
          BrickPattern.Full,
          BrickPattern.Full,
          BrickPattern.Half,
          BrickPattern.Full,
          BrickPattern.Full,
        ],
        margin: 0,
      },
      {
        pattern: [
          BrickPattern.Half,
          BrickPattern.Half,
          BrickPattern.Half,
          BrickPattern.Full,
          BrickPattern.Full,
          BrickPattern.Full,
          BrickPattern.Full,
          BrickPattern.Full,
          BrickPattern.Half,
          BrickPattern.Full,
          BrickPattern.Full,
          BrickPattern.Full,
          BrickPattern.Full,
          BrickPattern.Half,
          BrickPattern.Full,
          BrickPattern.Half,
        ],
        margin: -0.5,
      },
      {
        pattern: [
          BrickPattern.Full,
          BrickPattern.Full,
          BrickPattern.Full,
          BrickPattern.Half,
          BrickPattern.Full,
          BrickPattern.Full,
          BrickPattern.Full,
          BrickPattern.Half,
          BrickPattern.Full,
          BrickPattern.Full,
          BrickPattern.Half,
          BrickPattern.Full,
          BrickPattern.Full,
          BrickPattern.Full,
        ],
        margin: 0,
      },
      {
        pattern: [
          BrickPattern.Half,
          BrickPattern.Full,
          BrickPattern.Full,
          BrickPattern.Full,
          BrickPattern.Full,
          BrickPattern.Half,
          BrickPattern.Full,
          BrickPattern.Half,
          BrickPattern.Full,
          BrickPattern.Full,
          BrickPattern.Full,
          BrickPattern.Half,
          BrickPattern.Full,
          BrickPattern.Half,
          BrickPattern.Half,
          BrickPattern.Full,
        ],
        margin: -0.5,
      },
      {
        pattern: [
          BrickPattern.Half,
          BrickPattern.Full,
          BrickPattern.Full,
          BrickPattern.Half,
          BrickPattern.Full,
          BrickPattern.Full,
          BrickPattern.Half,
          BrickPattern.Full,
          BrickPattern.Full,
          BrickPattern.Half,
          BrickPattern.Full,
          BrickPattern.Full,
          BrickPattern.Half,
          BrickPattern.Full,
          BrickPattern.Full,
        ],
        margin: 0,
      },
      {
        pattern: [
          BrickPattern.Half,
          BrickPattern.Full,
          BrickPattern.Full,
          BrickPattern.Full,
          BrickPattern.Half,
          BrickPattern.Full,
          BrickPattern.Full,
          BrickPattern.Full,
          BrickPattern.Half,
          BrickPattern.Full,
          BrickPattern.Full,
          BrickPattern.Full,
          BrickPattern.Full,
          BrickPattern.Half,
          BrickPattern.Full,
        ],
        margin: -0.5,
      },
      {
        pattern: [
          BrickPattern.Full,
          BrickPattern.Half,
          BrickPattern.Half,
          BrickPattern.Full,
          BrickPattern.Full,
          BrickPattern.Half,
          BrickPattern.Full,
          BrickPattern.Half,
          BrickPattern.Full,
          BrickPattern.Full,
          BrickPattern.Full,
          BrickPattern.Half,
          BrickPattern.Full,
          BrickPattern.Full,
          BrickPattern.Full,
        ],
        margin: 0,
      },
      {
        pattern: [
          BrickPattern.Half,
          BrickPattern.Half,
          BrickPattern.Full,
          BrickPattern.Full,
          BrickPattern.Half,
          BrickPattern.Full,
          BrickPattern.Full,
          BrickPattern.Full,
          BrickPattern.Half,
          BrickPattern.Full,
          BrickPattern.Full,
          BrickPattern.Half,
          BrickPattern.Full,
          BrickPattern.Full,
          BrickPattern.Half,
          BrickPattern.Full,
        ],
        margin: -0.5,
      },
      {
        pattern: [
          BrickPattern.Full,
          BrickPattern.Full,
          BrickPattern.Half,
          BrickPattern.Full,
          BrickPattern.Half,
          BrickPattern.Full,
          BrickPattern.Full,
          BrickPattern.Full,
          BrickPattern.Half,
          BrickPattern.Full,
          BrickPattern.Full,
          BrickPattern.Full,
          BrickPattern.Half,
          BrickPattern.Half,
          BrickPattern.Full,
        ],
        margin: 0,
      },
      {
        pattern: [
          BrickPattern.Half,
          BrickPattern.Full,
          BrickPattern.Half,
          BrickPattern.Full,
          BrickPattern.Half,
          BrickPattern.Full,
          BrickPattern.Full,
          BrickPattern.Half,
          BrickPattern.Full,
          BrickPattern.Full,
          BrickPattern.Full,
          BrickPattern.Half,
          BrickPattern.Full,
          BrickPattern.Full,
          BrickPattern.Half,
        ],
        margin: -0.5,
      },
      {
        pattern: [
          BrickPattern.Half,
          BrickPattern.Full,
          BrickPattern.Half,
          BrickPattern.Full,
          BrickPattern.Full,
          BrickPattern.Full,
          BrickPattern.Full,
          BrickPattern.Half,
          BrickPattern.Full,
          BrickPattern.Full,
          BrickPattern.Half,
          BrickPattern.Half,
          BrickPattern.Full,
          BrickPattern.Full,
          BrickPattern.Full,
        ],
        margin: 0,
      },
    ],
  },
  [StructureType.Stack]: {
    name: "Gestapeld",
    rows: [{ pattern: [BrickPattern.Full], margin: -0.5 }],
  },
  [StructureType.Cross]: {
    name: "Kruis",
    rows: [
      { pattern: [BrickPattern.Full], margin: -0.5 },
      { pattern: [BrickPattern.Half], margin: -0.5 },
      { pattern: [BrickPattern.Full], margin: 0 },
      { pattern: [BrickPattern.Half], margin: -0.5 },
    ],
  },
  // [StructureType.Baekel]: {
  //   name: "Test",
  //   rows: [
  //     { pattern: [BrickPattern.Full], margin: -0.5 },
  //     { pattern: [BrickPattern.Baekel], margin: -0.25 },
  //     { pattern: [BrickPattern.Full], margin: 0 },
  //     { pattern: [BrickPattern.Baekel], margin: -0.25 },
  //   ],
  // },
};

export const JOINTS: JointClass[] = [
  {
    name: "5427",
    img:
      "https://brixture-storage-dev.s3-eu-west-1.amazonaws.com/joints/5427.jpg",
  },
  {
    name: "5886",
    img:
      "https://brixture-storage-dev.s3-eu-west-1.amazonaws.com/joints/5886.jpg",
  },
  {
    name: "5948",
    img:
      "https://brixture-storage-dev.s3-eu-west-1.amazonaws.com/joints/5948.jpg",
  },
  {
    name: "6032",
    img:
      "https://brixture-storage-dev.s3-eu-west-1.amazonaws.com/joints/6032.jpg",
  },
  {
    name: "6157",
    img:
      "https://brixture-storage-dev.s3-eu-west-1.amazonaws.com/joints/6157.jpg",
  },
  {
    name: "6302",
    img:
      "https://brixture-storage-dev.s3-eu-west-1.amazonaws.com/joints/6302.jpg",
  },
  {
    name: "6422",
    img:
      "https://brixture-storage-dev.s3-eu-west-1.amazonaws.com/joints/6422.jpg",
  },
  {
    name: "6481",
    img:
      "https://brixture-storage-dev.s3-eu-west-1.amazonaws.com/joints/6481.jpg",
  },
  {
    name: "905",
    img:
      "https://brixture-storage-dev.s3-eu-west-1.amazonaws.com/joints/905.jpg",
  },
  {
    name: "916",
    img:
      "https://brixture-storage-dev.s3-eu-west-1.amazonaws.com/joints/916.jpg",
  },
  {
    name: "917",
    img:
      "https://brixture-storage-dev.s3-eu-west-1.amazonaws.com/joints/917.jpg",
  },
  {
    name: "919",
    img:
      "https://brixture-storage-dev.s3-eu-west-1.amazonaws.com/joints/919.jpg",
  },
  {
    name: "920",
    img:
      "https://brixture-storage-dev.s3-eu-west-1.amazonaws.com/joints/920.jpg",
  },
  {
    name: "922",
    img:
      "https://brixture-storage-dev.s3-eu-west-1.amazonaws.com/joints/922.jpg",
  },
  {
    name: "925",
    img:
      "https://brixture-storage-dev.s3-eu-west-1.amazonaws.com/joints/925.jpg",
  },
  {
    name: "927",
    img:
      "https://brixture-storage-dev.s3-eu-west-1.amazonaws.com/joints/927.jpg",
  },
  {
    name: "929",
    img:
      "https://brixture-storage-dev.s3-eu-west-1.amazonaws.com/joints/929.jpg",
  },
  {
    name: "930",
    img:
      "https://brixture-storage-dev.s3-eu-west-1.amazonaws.com/joints/930.jpg",
  },
  {
    name: "931",
    img:
      "https://brixture-storage-dev.s3-eu-west-1.amazonaws.com/joints/931.jpg",
  },
  {
    name: "934",
    img:
      "https://brixture-storage-dev.s3-eu-west-1.amazonaws.com/joints/934.jpg",
  },
  {
    name: "935",
    img:
      "https://brixture-storage-dev.s3-eu-west-1.amazonaws.com/joints/935.jpg",
  },
  {
    name: "938",
    img:
      "https://brixture-storage-dev.s3-eu-west-1.amazonaws.com/joints/938.jpg",
  },
  {
    name: "939",
    img:
      "https://brixture-storage-dev.s3-eu-west-1.amazonaws.com/joints/939.jpg",
  },
  {
    name: "956",
    img:
      "https://brixture-storage-dev.s3-eu-west-1.amazonaws.com/joints/956.jpg",
  },
  {
    name: "957",
    img:
      "https://brixture-storage-dev.s3-eu-west-1.amazonaws.com/joints/957.jpg",
  },
  {
    name: "958",
    img:
      "https://brixture-storage-dev.s3-eu-west-1.amazonaws.com/joints/958.jpg",
  },
  {
    name: "96131",
    img:
      "https://brixture-storage-dev.s3-eu-west-1.amazonaws.com/joints/96131.jpg",
  },
  {
    name: "96133",
    img:
      "https://brixture-storage-dev.s3-eu-west-1.amazonaws.com/joints/96133.jpg",
  },
  {
    name: "9625",
    img:
      "https://brixture-storage-dev.s3-eu-west-1.amazonaws.com/joints/9625.jpg",
  },
  {
    name: "963",
    img:
      "https://brixture-storage-dev.s3-eu-west-1.amazonaws.com/joints/963.jpg",
  },
  {
    name: "9705",
    img:
      "https://brixture-storage-dev.s3-eu-west-1.amazonaws.com/joints/9705.jpg",
  },
  {
    name: "9707",
    img:
      "https://brixture-storage-dev.s3-eu-west-1.amazonaws.com/joints/9707.jpg",
  },
  {
    name: "9709",
    img:
      "https://brixture-storage-dev.s3-eu-west-1.amazonaws.com/joints/9709.jpg",
  },
  {
    name: "972",
    img:
      "https://brixture-storage-dev.s3-eu-west-1.amazonaws.com/joints/972.jpg",
  },
  {
    name: "9732",
    img:
      "https://brixture-storage-dev.s3-eu-west-1.amazonaws.com/joints/9732.jpg",
  },
  {
    name: "9752",
    img:
      "https://brixture-storage-dev.s3-eu-west-1.amazonaws.com/joints/9752.jpg",
  },
  {
    name: "976",
    img:
      "https://brixture-storage-dev.s3-eu-west-1.amazonaws.com/joints/976.jpg",
  },
  {
    name: "99128",
    img:
      "https://brixture-storage-dev.s3-eu-west-1.amazonaws.com/joints/99128.jpg",
  },
  {
    name: "99217",
    img:
      "https://brixture-storage-dev.s3-eu-west-1.amazonaws.com/joints/99217.jpg",
  },
  {
    name: "99245",
    img:
      "https://brixture-storage-dev.s3-eu-west-1.amazonaws.com/joints/99245.jpg",
  },
  {
    name: "99347",
    img:
      "https://brixture-storage-dev.s3-eu-west-1.amazonaws.com/joints/99347.jpg",
  },
  {
    name: "99361",
    img:
      "https://brixture-storage-dev.s3-eu-west-1.amazonaws.com/joints/99361.jpg",
  },
  {
    name: "99474",
    img:
      "https://brixture-storage-dev.s3-eu-west-1.amazonaws.com/joints/99474.jpg",
  },
  {
    name: "99487",
    img:
      "https://brixture-storage-dev.s3-eu-west-1.amazonaws.com/joints/99487.jpg",
  },
  {
    name: "99505",
    img:
      "https://brixture-storage-dev.s3-eu-west-1.amazonaws.com/joints/99505.jpg",
  },
  {
    name: "99527",
    img:
      "https://brixture-storage-dev.s3-eu-west-1.amazonaws.com/joints/99527.jpg",
  },
  {
    name: "99595",
    img:
      "https://brixture-storage-dev.s3-eu-west-1.amazonaws.com/joints/99595.jpg",
  },
  {
    name: "99816",
    img:
      "https://brixture-storage-dev.s3-eu-west-1.amazonaws.com/joints/99816.jpg",
  },
];
